// extracted by mini-css-extract-plugin
export default {"banner":"BusinessPartnerStatusBanner_banner__4ixsz"};